import { ChangeEvent } from 'react';

import { EmailOutlined, LinkOutlined } from '@mui/icons-material';
import { Box, Button, DialogContent, Divider, TextField, Typography } from '@mui/material';

const ShareDialogContent = ({
  header,
  shareUrl,
  onCopyClick,
  emailError,
  recipient,
  handleChangeRecipient,
  onSendEmail,
  content,
  onContentChange
}: {
  header: string;
  shareUrl: string;
  onCopyClick: () => void;
  emailError: string;
  recipient: string;
  handleChangeRecipient: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSendEmail: () => Promise<void>;
  content: string;
  onContentChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) => {
  return (
    <DialogContent
      sx={{ backgroundColor: 'background.default', minWidth: 540, '& p': { fontWeight: 700 } }}
    >
      <Typography variant='h5'>{header}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 3 }}>
        <LinkOutlined sx={{ mr: 1 }} />
        <Typography>Share a link</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          hiddenLabel
          sx={{
            fontSize: 14,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textWrap: 'nowrap',
            flexGrow: 1,
            '& .MuiFilledInput-input': {
              py: '14px!important'
            },
            '& .MuiInputBase-root': {
              backgroundColor: '#4F545873'
            }
          }}
          value={shareUrl}
          variant='filled'
        />
        <Button
          color='primary'
          sx={{ ml: 1, height: 48, width: 120, minWidth: 120 }}
          variant='contained'
          onClick={onCopyClick}
        >
          Copy link
        </Button>
      </Box>
      <Box sx={{ position: 'relative' }}>
        <Divider sx={{ my: 5, color: 'info.dark' }} />
        <Box
          sx={{
            backgroundColor: 'background.default',
            position: 'absolute',
            left: '50%',
            top: -16,
            fontSize: 12,
            p: 1,
            color: 'info.dark'
          }}
        >
          OR
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <EmailOutlined sx={{ mr: 1 }} />
        <Typography>Share via email</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'start', height: 70 }}>
        <TextField
          hiddenLabel
          error={!!emailError}
          helperText={emailError}
          placeholder="Enter the recipient's email..."
          sx={{
            fontSize: 14,
            flexGrow: 1,
            '& .MuiFilledInput-input': {
              py: '14px!important'
            },
            '& .MuiInputBase-root': {
              backgroundColor: '#4F545873'
            }
          }}
          value={recipient}
          variant='filled'
          onChange={handleChangeRecipient}
        />
        <Button
          color='primary'
          sx={{ ml: 1, height: 48, width: 120 }}
          variant='contained'
          onClick={onSendEmail}
        >
          Send an email
        </Button>
      </Box>
      <Typography sx={{ my: 1, fontSize: 14 }}>Message (Optional)</Typography>
      <TextField
        fullWidth
        hiddenLabel
        multiline
        maxRows={5}
        placeholder='Type your message...'
        rows={3}
        value={content}
        variant='outlined'
        onChange={onContentChange}
      />
    </DialogContent>
  );
};
export default ShareDialogContent;
